module.exports = __webpack_public_path__ + "img/dsci0004.f7e62c80.jpg";